import { render, staticRenderFns } from "./Codemirror.vue?vue&type=template&id=47b3dab4&"
import script from "./Codemirror.vue?vue&type=script&lang=js&"
export * from "./Codemirror.vue?vue&type=script&lang=js&"
import style0 from "./Codemirror.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports